/**
 * CRM 2.0 — US-003 RBAC Gating
 *
 * <Can permission="users.read">…</Can>
 *
 * Renders children only when the authenticated admin holds the given permission.
 * Uses PermissionsContext — no external RBAC lib.
 *
 * Props:
 *   permission   — a single permission key (e.g. "users.read")
 *   fallback     — optional element to render when permission is missing (default: null)
 *   loading      — element to render while /me is still loading (default: null)
 *
 * Example:
 *   <Can permission="users.delete">
 *     <Button onClick={handleDelete}>Löschen</Button>
 *   </Can>
 *
 *   <Can permission="admins.read" fallback={<p>Kein Zugriff</p>}>
 *     <RollenPage />
 *   </Can>
 */
import React from 'react';
import { usePermissions } from '../../contexts/PermissionsContext';

interface CanProps {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  loading?: React.ReactNode;
}

export function Can({ permission, children, fallback = null, loading: loadingEl = null }: CanProps) {
  const { hasPermission, loading } = usePermissions();

  if (loading) return <>{loadingEl}</>;
  if (!hasPermission(permission)) return <>{fallback}</>;
  return <>{children}</>;
}
